/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconError509 = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--error509',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.1 136.7"{...rest}><path className="path1" fill="#00A1DE" d="M164.3 136.7H8.7c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7h155.6c4.8 0 8.7 3.9 8.7 8.7.1 4.8-3.9 8.7-8.7 8.7z"/><path className="path2" fill="#004BB7" d="M114.3 136.7H8.7c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7h105.5c4.8 0 8.7 3.9 8.7 8.7.1 4.8-3.8 8.7-8.6 8.7z"/><path className="path3" fill="#0068C6" d="M69.5 54.3h34.1v75.6H69.5z"/><path className="path4" fill="#0068C6" d="M116.4 130.9H56.6c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9h59.8c1.6 0 2.9 1.3 2.9 2.9.1 1.6-1.3 2.9-2.9 2.9z"/><path className="path5" fill="#00A1DE" d="M168.3 108.7H4.8c-2.6 0-4.8-2.1-4.8-4.8V4.8C0 2.1 2.1 0 4.8 0h163.5c2.6 0 4.8 2.1 4.8 4.8v99.1c0 2.6-2.2 4.8-4.8 4.8z"/><path className="path6" fill="#0068C6" d="M0 4.8v99.1c0 2.6 2.1 4.8 4.8 4.8h163.5c2.6 0 4.8-2.1 4.8-4.8"/><path className="path7" fill="#004BB7" d="M69.5 125v-16.3h34.1z"/><path className="path8" fill="#6ACEE5" d="M160.9 99.9H10.6c-1.1 0-2.1-.9-2.1-2.1V11.4c0-1.1.9-2.1 2.1-2.1h150.3c1.1 0 2.1.9 2.1 2.1v86.4c0 1.2-.9 2.1-2.1 2.1z"/><path className="path9" fill="#004BB7" d="M93 52.5h-2.6v-4.1c0-2.6-2.1-4.7-4.7-4.7S81 45.8 81 48.4v4.1h-2.6v-4.1c0-4 3.3-7.3 7.3-7.3s7.3 3.3 7.3 7.3v4.1z"/><path className="path10" fill="#004BB7" d="M93 67.9H78.6c-1.6 0-3-1.3-3-3V54.2c0-1.6 1.3-3 3-3H93c1.6 0 3 1.3 3 3v10.7c-.1 1.6-1.4 3-3 3z"/></IconBase>
  )
}

IconError509.propTypes = {
  className: PropTypes.string,
}

export default IconError509
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconError509.js